{
  "close": "Fermer",
  "notifications": "{count, plural, one {# notification} other {# notifications}}."
}
